import { useCallback } from "react";
import {
  EModalId,
  EModalSize,
  useModalContext,
} from "../ui/Modal/modal-context";
import PasswordResetModal from "./PasswordResetModal";

export const usePasswordResetModal = () => {
  const { addModal, closeModal } = useModalContext();

  const closeModalHandler = useCallback(
    () => closeModal(EModalId.CHANGE_PASSWORD),
    [closeModal]
  );

  const openPasswordResetModal = (defaultEmail: string = "") => {
    return new Promise<boolean>((resolve) => {
      addModal({
        id: EModalId.CHANGE_PASSWORD,
        isOpen: true,
        size: EModalSize.SMALL,
        title: defaultEmail ? "Change Password" : "Reset Password",
        onModalClose: () => resolve(false),
        content: (
          <PasswordResetModal
            defaultEmail={defaultEmail}
            onCancel={() => {
              closeModalHandler();
              resolve(true);
            }}
          />
        ),
      });
    });
  };

  return openPasswordResetModal;
};
